export default __webpack_public_path__ + "static/media/all_product_ico.75231141.svg";